import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild,} from '@angular/core';
import { AppComponent } from '../../../app.component';
import { callService } from '../../../data.service';
import {ConfigApp, microServices} from '../../../config';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import PubSub from 'pubsub-js'

@Component({
  selector: 'app-page-dashboard',
  templateUrl: './page-dashboard.component.html',
})
export class PageDashboardComponent
  extends AppComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  resultsTable: any[];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  loadingTable: boolean = true;
  timingUpdate: Date = new Date();

  elementSelect: any;
  eventFilter: any;
  textErrorUpload: string = '';
  saveIdCheck:any[]=[];
  loadingModal:boolean = false;

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      stateSave: true,
      language: {
        emptyTable: 'Nessun dato presente nella tabella',
        info: 'Vista da _START_ a _END_ di _TOTAL_ elementi',
        infoEmpty: 'Vista da 0 a 0 di 0 elementi',
        infoFiltered: '(filtrati da _MAX_ elementi totali)',
        infoPostFix: '',
        thousands: '.',
        lengthMenu: 'Visualizza _MENU_ elementi',
        loadingRecords: 'Caricamento...',
        processing: 'Elaborazione...',
        search: 'Cerca:',
        zeroRecords: 'La ricerca non ha portato alcun risultato.',
        paginate: {
          first: 'Inizio',
          previous: '<i class="uil uil-angle-left"></i>',
          next: '<i class="uil uil-angle-right"></i>',
          last: 'Fine',
        },
        aria: {
          sortAscending: ': attiva per ordinare la colonna in ordine crescente',
          sortDescending:
            ': attiva per ordinare la colonna in ordine decrescente',
        },
      },
      order: [[ this.infoUserLogin.user.isAdmin() ? 4:3, "desc" ]],
      /*columnDefs: [
        { targets: this.infoUserLogin.user.isAdmin() ? 4:3 }
      ]*/
    };

    AppComponent.hideLoading();

    this.generateTable();

    if (this.config.microServices.polling.active) {
      setInterval(() => {
        this.generateTable();
      }, this.config.microServices.polling.time);
    }

    this.eventFilter = PubSub.subscribe('filter-data', (msg, data)=>{
      this.resultsTable = [];
      data.forEach(val => this.resultsTable.push(Object.assign({}, val)));
      this.rerender();
    });
  }

  fileError(file){
    if(file.xml_file_name) return file.xml_file_name.split('.')[0]+'_errors.xlsx';
    if(file.temp_file_name) return file.temp_file_name.split('.')[0]+'_errors.xlsx';
  }

  rerender() {
    if (this.datatableElement) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });

      let that = this;

      //@ts-ignore
      window.$(".btn.btn-outline-info.fileInfo").on("click",function(e){
        let id = $(this).attr("data-file");
        if(!id) id = $(this.parentElement).attr("type");
        let foundFile = that.resultsTable.filter((item)=>{
          return item.OBJECTID == id;
        })
        if(foundFile && foundFile.length){
          that.starTrashDeleteFile(e,foundFile[0]);
        }
      });

      //@ts-ignore
      window.$(".btn-danger.tdTash").on("click",function(e){
        let id = $(this).attr("data-file");
        if(!id) id = $(this.parentElement).attr("type");
        let foundFile = that.resultsTable.filter((item)=>{
          return item.OBJECTID == id;
        })
        if(foundFile && foundFile.length){
          that.starTrashDeleteFile(e,foundFile[0]);
        }
      });

      //@ts-ignore
      window.$(".btn-outline-danger.tdDelete").on("click",function(){
        let id = $(this).attr("data-file");
        if(!id) id = $(this.parentElement).attr("type");
        let foundFile = that.resultsTable.filter((item)=>{
          return item.OBJECTID == id;
        })
        if(foundFile && foundFile.length){
          that.infoStatusFile(foundFile[0]);
        }
      });

      setTimeout(()=>{

        //@ts-ignore
        window.$('tbody').on('click', ()=>{
          setTimeout(()=>{
            //@ts-ignore
            window.$('tbody').find(".btn.btn-outline-info.fileInfo").unbind('click');
            //@ts-ignore
            window.$('tbody').find(".btn.btn-outline-info.fileInfo").on("click",(e)=>{
              let id = $(e.target).attr("type");
              if(!id) id = $(e.target.parentElement).attr("type");
              let foundFile = this.resultsTable.filter((item)=>{
                return item.OBJECTID == id;
              })
              if(foundFile && foundFile.length){
                this.infoStatusFile(foundFile[0]);
              }
            });

            //@ts-ignore
            window.$('tbody').find(".btn-danger.tdTash").unbind('click');
            //@ts-ignore
            window.$(".btn-danger.tdTash").on("click",function(e){
              let id = $(this).attr("data-file");
              if(!id) id = $(this.parentElement).attr("type");
              let foundFile = that.resultsTable.filter((item)=>{
                return item.OBJECTID == id;
              })
              if(foundFile && foundFile.length){
                that.starTrashDeleteFile(e,foundFile[0]);
              }
            });

            //@ts-ignore
            window.$('tbody').find(".btn-outline-danger.tdDelete").unbind('click');
            //@ts-ignore
            window.$(".btn-outline-danger.tdDelete").on("click",function(){
              let id = $(this).attr("data-file");
              if(!id) id = $(this.parentElement).attr("type");
              let foundFile = that.resultsTable.filter((item)=>{
                return item.OBJECTID == id;
              })
              if(foundFile && foundFile.length){
                that.infoStatusFile(foundFile[0]);
              }
            });
          },20);
        });
      },500);

    }
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  generateTable() {
    this.timingUpdate = new Date();
    if (this.config.debugListFile) {
      //esempio codice in debug
      let responseService = {
        response: {
          valid: true,
          errorMessage: '',
          request: {
            user: '',
            password: '',
            codiceCliente: '',
            service: 'filesList',
            parameters: {},
          },
          result: {
            files: [
              {
                OBJECTID: 1,
                file_name: 'Marche20211216.xml',
                group_name: 'Mosaico - Marche',
                file_type: 'File XML',
                temp_file_name: 'Marche20211216.xml',
                xml_file_name: 'Marche20211216.xml',
                creation_date: '04/03/2022 18:34:43',
                status: 'Verificato',
              },
              {
                OBJECTID: 2,
                file_name:
                  'TemplateTrasmissioneDati_v4.9_Veneto_rev_ARPAV_1di2_20 gennaio.xlsx',
                group_name: 'Mosaico - Veneto',
                file_type: 'Excelx',
                temp_file_name:
                  'TemplateTrasmissioneDati_v4.9_Veneto_rev_ARPAV_1di2_20 gennaio.xlsx',
                xml_file_name:
                  'TemplateTrasmissioneDati_v4.9_Veneto_rev_ARPAV_1di2_20 gennaio20220304_190431165557.xml',
                creation_date: '04/03/2022 18:35:43',
                status: 'Verificato',
              },
              {
                OBJECTID: 401,
                file_name: 'Sicilia_discariche_12gen.zip',
                group_name: 'Mosaico - Sicilia',
                file_type: 'Zip (Excel & Shape)',
                temp_file_name: 'Sicilia_discariche_12gen.zip',
                xml_file_name:
                  'TemplateTrasmissioneDati_v4.9_Sicilia_discariche20220307_180242926141.xml',
                creation_date: '07/03/2022 13:03:38',
                status: 'Verificato',
              },
            ],
          },
          jsonschema: {
            type: 'object',
            properties: {
              user: { type: 'string' },
              password: { type: 'string' },
              codiceCliente: { type: 'string' },
              service: { type: 'string' },
              parameters: { type: 'object' },
            },
            required: [
              'user',
              'password',
              'codiceCliente',
              'service',
              'parameters',
            ],
          },
          jsonschemaparameters: {
            type: 'object',
            properties: { parameters: { type: 'object', required: [] } },
            required: [],
          },
        },
      };

      this.resultsTable = responseService.response.result.files;
      this.rerender();
      this.loadingTable = false;
      setTimeout(()=>{
        PubSub.publish('filter-clean', "");
        PubSub.publish('new-data', this.resultsTable);
      },500);

      return;
    }
    let microServicesFilesList = Object.assign({}, microServices.filesList);
    this.controlCallMicroService(microServicesFilesList).then((result) => {
      if (result) {
        if (this.infoUserLogin.user.isAdmin()) {
          this.resultsTable = result.response.result.files;
        } else {
          this.resultsTable = result.response.result.files.filter((file) => {
            return file.group_name === this.infoUserLogin.user.groupsMosaico;
          });
        }
        this.resultsTable = this.resultsTable.filter((file)=>{
          return file.status.toUpperCase() !== this.config.statusDelete;
        });

      }else{
        this.resultsTable = [];
      }

      this.resultsTable.sort((a,b)=>{
        if (this.getTime(a.creation_date) < this.getTime(a.creation_date)) {
          return -1;
        }
        if (this.getTime(a.creation_date) > this.getTime(a.creation_date)) {
          return 1;
        }
        return 0;
      });

      this.rerender();

      this.loadingTable = false;
      setTimeout(()=>{
        PubSub.publish('filter-clean', "");
        PubSub.publish('new-data', this.resultsTable);
      },500);
    });
  }

  /** ==============================================
   * UTILITY
   ===============================================**/

  getTime(dateString) {
    let date = dateString.split(" ")[0].split("/");
    return new Date(date[3]+"-"+date[2]+"-"+date[1]).getTime();
  }

  customDateStamp(d) {
    return (
      ('0' + d.getDate()).slice(-2) +
      '-' +
      ('0' + (d.getMonth() + 1)).slice(-2) +
      '-' +
      d.getFullYear() +
      ' ' +
      ('0' + d.getHours()).slice(-2) +
      ':' +
      ('0' + d.getMinutes()).slice(-2)
    );
  }

  foundStatusByText(status) {
    let statusFound = this.config.statusFile.filter(function (item) {
      return item.label.toLowerCase() === status.toLowerCase();
    });
    if (statusFound && statusFound.length) {
      return statusFound[0];
    } else {
      console.warn('Status not found, change config.json: status : ' + status);
    }
    return null;
  }

  foundClassStatus(status) {
    let statusFound = this.foundStatusByText(status);
    if (statusFound) {
      return statusFound.classBootstrap;
    }
    return '';
  }

  isStatusCanInsert(status) {
    return status.toLowerCase() === this.config.statusCanInsert.toLowerCase();
  }

  isStatusCanValidate(status) {
    return status.toLowerCase() === this.config.statusCanValidate.toLowerCase();
  }

  isStatusTrash(status) {
    return status.toLowerCase() === this.config.statusTrash.toLowerCase();
  }

  /** ==============================================
   * CONTROL
   ===============================================**/

  async controlCallMicroService(service) {
    if(ConfigApp.loadingAllCall) this.loadingModal= true;
    let result = await callService(service);
    if(ConfigApp.loadingAllCall) this.loadingModal = false;
    if (result && result && result.response) {
      if (result.response.valid && result.response.errorMessage === '') {
        return result;
      } else {
        let messageError = "Errore messaggio non valido";
        if(result.response){
          if(result.response.errorMessage) messageError = result.response.errorMessage;
          else messageError = result.response;
        }

        console.warn(messageError);
        console.warn(JSON.stringify(result));
      }
    } else {
      console.warn(JSON.stringify(result));
    }
    return false;
  }

  controlValidateInsert(file) {
    if (this.isStatusCanValidate(file.status)) {
      //VALIDA
      file.validateInsert = {
        idStatusNext: this.foundStatusByText(this.config.statusToValidate).id,
        canValidate: true,
        class: 'btn-outline-warning tdValidate',
        label: 'Verifica',
        icon: 'dripicons-search',
      };
      return true;
    } else if (this.isStatusCanInsert(file.status)) {
      //INSERISCI
      file.validateInsert = {
        idStatusNext: this.foundStatusByText(this.config.statusToInsert).id,
        canInsert: true,
        class: 'btn btn-outline-success tdInsert',
        label: 'Inserisci',
        icon: 'dripicons-cloud-upload',
      };
      return true;
    }

    return false;
  }

  controlErrorExist(status) {
    let foundStatusConfig = this.foundStatusByText(status);
    return foundStatusConfig.canError;
  }

  controlTrashDelete(file) {
    let foundStatusConfig = this.foundStatusByText(file.status);
    file.trashDelete = !this.isStatusTrash(file.status)
      ? //SCARTARE
      {
        canTrash: true,
        idStatusNext: this.foundStatusByText(this.config.statusTrash).id,
        class: 'btn-danger tdTash',
        label: 'Scarta',
        icon: 'dripicons-trash',
      }
      : //CANCELLARE
      {
        canDelete: true,
        idStatusNext: this.foundStatusByText(this.config.statusDelete).id,
        class: 'btn-outline-danger tdDelete',
        label: 'Elimina',
        icon: 'dripicons-document-delete',
      };

    return this.isStatusTrash(file.status)
      ? foundStatusConfig.canDelete
      : foundStatusConfig.canTrash;
  }

  /** ==============================================
   * PAGE EVENT
   ===============================================**/

  uploadFile(input) {
    var formData = new FormData();
    formData.append('f', "json");
    formData.append('file', input.files[0]);
    this.loadingTable = true;
    callService(
      {
        method: 'POST',
        url: this.config.microServices.uploadFile,
        params: formData,
      },
      null,
      true
    ).then((response) => {
      if (response && response.success) {
        // @ts-ignore
        window.$('#success-alert-modal').modal('toggle');

        let microServicesCreateFile = Object.assign({}, microServices.createFile);
        microServicesCreateFile.params.parameters.file_name = input.files[0].name;
        microServicesCreateFile.params.parameters.temp_file_name = response.fileName;
        microServicesCreateFile.params.parameters.group_name = this.infoUserLogin.user.groupsMosaico;

        this.controlCallMicroService(microServicesCreateFile).then((result) => {
          if(result) this.generateTable();
        });

      } else {
        if (response.errorMessage) {
          this.textErrorUpload = response.errorMessage;
          // @ts-ignore
          window.$('#warning-alert-modal').modal('toggle');
        }
      }
    });
  }

  infoStatusFile(file) {
    this.elementSelect = {
      file: file,
      listStatus: null,
    };

    let microServicesFileStatus = Object.assign({}, microServices.fileStatus);
    if (file && file.OBJECTID) {
      microServicesFileStatus.params.parameters.file_id = file.OBJECTID;

      this.loadingModal = true;
      this.controlCallMicroService(microServicesFileStatus).then((result) => {
        if (result) {
          this.elementSelect.listStatus = result.response.result.status;
          // @ts-ignore
          window.$('#detailsStatus').modal('show');
          this.loadingModal = false;
        }
      });
    }
  }

  startValidateInsert(event, file, multiple:boolean = false) {
    if(!multiple){
      event.preventDefault();
      event.stopPropagation();
      let text = file.validateInsert && file.validateInsert.canInsert
        ? 'Sei sicuro di inserire questo file?'
        : 'Sei sicuro di verificare questo file?';
      if (!confirm(text)) return;
    }

    let microServicesChangeStatus = Object.assign(
      {},
      microServices.changeStatus
    );
    if (file && file.validateInsert) {
      microServicesChangeStatus.params.parameters.file_id = file.OBJECTID;
      microServicesChangeStatus.params.parameters.status = file.validateInsert.idStatusNext;

      this.controlCallMicroService(microServicesChangeStatus).then((result) => {
        if (result) {
          //Se file da verificare chiama metodo verifyFile altrimenti se è da inserire chiama insertFile
          let serviceValidateOrInsert = file.validateInsert.canValidate
            ? Object.assign({}, microServices.verifyFile)
            : file.validateInsert.canInsert
              ? Object.assign({}, microServices.insertFile)
              : null;
          serviceValidateOrInsert.params.parameters.file_id = file.OBJECTID;
          this.controlCallMicroService(serviceValidateOrInsert).then((result) => {
            if (!multiple && result) this.generateTable();
          });

          //setTimeout(()=>{
          this.generateTable();
          //},500);

        }
      });
    }
  }

  starTrashDeleteFile(event, file, multiple:boolean = false) {
    if(!multiple){
      event.preventDefault();
      event.stopPropagation();
      let text = file.trashDelete && file.trashDelete.canTrash
        ? 'Sei sicuro di scartare questo file?'
        : 'Sei sicuro di cancellare questo file?';
      if (!confirm(text)) return;
    }

    let microServicesChangeStatus = Object.assign(
      {},
      microServices.changeStatus
    );
    if (file && file.trashDelete) {
      microServicesChangeStatus.params.parameters.file_id = file.OBJECTID;
      microServicesChangeStatus.params.parameters.status =
        file.trashDelete.idStatusNext;

      this.controlCallMicroService(microServicesChangeStatus).then((result) => {
        if (!multiple && result) this.generateTable();
      });

      this.generateTable();
    }
  }

  /** ==============================================
   * MULTIPLE ACTIONS
   ===============================================**/

  listFileByInput(){
    // @ts-ignore
    let arrayInputCheck = window.$("input:checked");
    let arrayFileSelect = [];
    for(let i=0;i<arrayInputCheck.length;i++){
      let nodeCheck = arrayInputCheck[i];
      let id = nodeCheck.getAttribute("data-file");

      let foundFile = this.resultsTable.filter(function(item){return item.OBJECTID==id;});
      if(foundFile && foundFile.length){
        arrayFileSelect.push(foundFile[0]);
      }
    }
    return arrayFileSelect;
  }

  multipleVerify(){
    let text = 'Sei sicuro di verificare questi file?';
    if (!confirm(text)) return;

    let arrayFileSelect = this.listFileByInput().filter(function(item){
      return item && item.validateInsert && item.validateInsert.canValidate
    });

    for(let i=0;i<arrayFileSelect.length;i++){
      this.startValidateInsert(null,arrayFileSelect[i],true);
    }

    this.generateTable();
  }

  multipleInsert(){
    let text = 'Sei sicuro di inserire questi file?';
    if (!confirm(text)) return;

    let arrayFileSelect = this.listFileByInput().filter(function(item){
      return item && item.validateInsert && item.validateInsert.canInsert
    });

    for(let i=0;i<arrayFileSelect.length;i++){
      this.startValidateInsert(null,arrayFileSelect[i],true);
    }

    this.generateTable();
  }

  multipleTrash(){
    let text = 'Sei sicuro di scartare questi file?';
    if (!confirm(text)) return;

    let arrayFileSelect = this.listFileByInput().filter(function(item){
      return item && item.trashDelete && item.trashDelete.canTrash
    });

    for(let i=0;i<arrayFileSelect.length;i++){
      this.starTrashDeleteFile(null,arrayFileSelect[i],true);
    }

    this.generateTable();
  }

  multipleDelete(){
    let text = 'Sei sicuro di cancellare questi file?';
    if (!confirm(text)) return;

    let arrayFileSelect = this.listFileByInput().filter(function(item){
      return item && item.trashDelete && item.trashDelete.canDelete
    });


    for(let i=0;i<arrayFileSelect.length;i++){
      this.starTrashDeleteFile(null,arrayFileSelect[i],true);
    }

    this.generateTable();
  }

  convertStringToTimestamp(date){
    return new Date(date).getTime();
  }

  convertStringToDateYYYYMMDD(date){
    //let d = new Date(date.trim());
    //let newData = d.getFullYear() + "/" + (d.getMonth()+1<10?'0':'')+(d.getMonth() + 1) + "/" + (d.getDate()<10?'0':'') + d.getDate()+" " +d.getHours() + ":" + (d.getMinutes()<10?'0':'') +d.getMinutes() + ":" + (d.getSeconds()<10?'0':'') +d.getSeconds();
    //console.log(date+" -> "+newData);
    //return newData;

    let d = date.replaceAll("/","-");
    let ad = d.split(" ");
    let d2 = ad[0].split("-");
    return d2[2]+"-"+d2[1]+"-"+d2[0]+" "+ad[1];
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
    if(this.eventFilter){
      PubSub.unsubscribe(this.eventFilter);
    }
  }
}
